import {GenCounty} from '../../generated/serverModels/GenCounty';

export class County extends GenCounty {
  constructor(county?: County | GenCounty) {
    super(county);

  }

}
